import React, { useState, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import "./assets/css/advertise.css";

const AdvertiseForm = () => {
  const [status, setStatus] = useState("");
  const [advDisable, setAdvDisable] = useState(false);
  const [count, setCount] = useState(0);

  const { baseUrl, token } = useContext(AppContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      adv_disable: advDisable,
      count: count,
    };

    try {
      const res = await axios.post(`${baseUrl}/save-advertise`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        setStatus("Advertise entry saved successfully!");
        setAdvDisable(false);
        setCount(0);
        setTimeout(() => setStatus(""), 3000);
      } else {
        setStatus(res.data.message || "Failed to save advertise entry");
      }
    } catch (err) {
      console.error("Save error:", err);
      setStatus("Error saving advertise entry");
    }
  };

  return (
    <div className="container">
      <div className="advertise_main">
        <h1 className="heading">Add Advertise</h1>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="main_model">
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div className="form_field">
              <label>
                <input
                  type="checkbox"
                  checked={advDisable}
                  onChange={(e) => setAdvDisable(e.target.checked)}
                />
                Disable Advertise
              </label>
            </div>
            <div className="form_field">
              <label>Count</label>
              <input
                type="number"
                value={count}
                onChange={(e) => setCount(Number(e.target.value))}
                className="form-control"
                required
              />
            </div>

            <div className="form_btn">
              <button type="submit" className="btn btn-primary">
                Save Advertise
              </button>
              <div style={{ color: "green", marginTop: "10px" }}>{status}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdvertiseForm;
